import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const formatValue = (value) => {
    if (value) {
        return value.substr(0, 10);
    }

    return null;
};

const RenderDateInputField = (props) => {
    const {
        className,
        defaultValue,
        disabled,
        floatingLabelFixed,
        fullWidth,
        input: {
            name,
            onBlur,
            onChange,
            onFocus,
            value,
        },
        label,
        meta: { touched, error },
        placeholder,
        style,
        type,
    } = props;

    return (
        <TextField
            className={ className }
            disabled={ disabled }
            errorText={ touched && error }
            floatingLabelText={ label }
            floatingLabelFixed={ floatingLabelFixed }
            fullWidth={ fullWidth }
            hintText={ placeholder }
            id={ name }
            name={ name }
            onBlur={ onBlur }
            onChange={ onChange }
            onFocus={ onFocus }
            style={ style }
            type={ type }
            value={ formatValue(value) || defaultValue }
        />
    );
};

RenderDateInputField.defaultProps = {
    defaultValue: '',
    fullWidth: false,
    floatingLabelFixed: false,
    type: 'date',
};

RenderDateInputField.propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        onFocus: PropTypes.func,
        value: PropTypes.value,
    }).isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    placeholder: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.string,
    type: PropTypes.oneOf([
        'date',
        'month',
        'year',
    ]),
};

export default RenderDateInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderDateInputField.js